//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import { DashboardConfig } from '@/__configs/config_types';

const dashboardConfig: DashboardConfig = {
  statusCards: [
    {
      name: 'Awaiting Assets',
      status: 'awaiting_assets',
      color: 'default',
      filter: ['awaiting_assets'],
      icon: 'clock'
    },
    {
      name: 'Review',
      status: 'ready_for_review',
      color: 'warning',
      icon: 'timelapse',
      filter: ['review', 'prep_for_review', 'internal_bcm_qc', 'tech_review', 'supr_review', 'asset_workorder']
    },
    {
      name: 'Edit',
      status: 'ready_for_edit',
      color: 'pending',
      filter: ['prep_for_edit', 'edit', 'update_metadata'],
      icon: 'clock_progress'
    },
    {
      name: 'Processing',
      status: 'process_and_confirm',
      color: 'info',
      filter: [
        'packaging',
        'render',
        'send',
        'deliver_to_encompass',
        'edit_ingest',
        'fetch_metadata',
        'ingest',
        'prep_for_encompass',
        'send_to_encompass',
        'prep_for_render',
        'processing',
        'prepare_send'
      ],
      icon: 'flight'
    },
    {
      name: 'Completed',
      status: 'completed',
      color: 'success',
      ignoreOnPieChart: true,
      filter: ['completed'],
      icon: 'check'
    }
  ],
  customizeDashboard: true,
  graphList: [
    {
      id: 'open-job-status',
      checked: true
    },
    {
      id: 'completed-jobs',
      checked: true
    },
    {
      id: 'average-times',
      checked: true
    },
    {
      id: 'daily-reports',
      checked: true
    },
    {
      id: 'recent-tasks',
      checked: false
    }
  ],
  graphSettings: {
    'completed-jobs': {
      displayed_job_types: ['edit', 'delivery', 'tech_review']
    }
  },
  maximumGraphsPerRow: 3,
  chartColors: ['#BC13FE', '#FF1493', 'info', '#39FF14']
};

export default dashboardConfig;
